import * as styles from "./Socials.css";
import { ButtonLink } from "./ButtonLink";
import { Socials as ISocials } from "~/sanity/types";
// @ts-ignore
import { Facebook } from "~/assets/svgs/icons/socials/Facebook";
import { Instagram } from "~/assets/svgs/icons/socials/Instagram";
import { Youtube } from "~/assets/svgs/icons/socials/Youtube";
import { ButtonProps } from "./Button";
import { LinkedIn } from "~/assets/svgs/icons/socials/LinkedIn";
import { XTwitter } from "~/assets/svgs/icons/socials/XTwitter";
import { TikTok } from "~/assets/svgs/icons/socials/TikTok";

export type SocialsProps = {
  theme?: ButtonProps["theme"];
  isPrimary?: ButtonProps["isPrimary"];
  size?: ButtonProps["size"];
} & ISocials;

export const Socials = ({
  facebook,
  instagram,
  youtube,
  linkedin,
  twitter,
  tiktok,
  theme = "dark",
  isPrimary = false,
  size = "md",
  ...props
}: SocialsProps) => {
  return (
    <div className={styles.container} {...props}>
      {facebook && (
        <ButtonLink
          theme={theme}
          isPrimary={isPrimary}
          size={size}
          icons={{ iconPrimary: <Facebook /> }}
          link={{
            _type: "link",
            type: "external",
            newTab: true,
            slug: facebook,
          }}
        />
      )}
      {instagram && (
        <ButtonLink
          theme={theme}
          isPrimary={isPrimary}
          size={size}
          icons={{ iconPrimary: <Instagram /> }}
          link={{
            _type: "link",
            type: "external",
            newTab: true,
            slug: instagram,
          }}
        />
      )}
      {youtube && (
        <ButtonLink
          theme={theme}
          isPrimary={isPrimary}
          size={size}
          icons={{ iconPrimary: <Youtube /> }}
          link={{
            _type: "link",
            type: "external",
            newTab: true,
            slug: youtube,
          }}
        />
      )}
      {linkedin && (
        <ButtonLink
          theme={theme}
          isPrimary={isPrimary}
          size={size}
          icons={{ iconPrimary: <LinkedIn /> }}
          link={{
            _type: "link",
            type: "external",
            newTab: true,
            slug: linkedin,
          }}
        />
      )}
      {twitter && (
        <ButtonLink
          theme={theme}
          isPrimary={isPrimary}
          size={size}
          icons={{ iconPrimary: <XTwitter /> }}
          link={{
            _type: "link",
            type: "external",
            newTab: true,
            slug: twitter,
          }}
        />
      )}
      {tiktok && (
        <ButtonLink
          theme={theme}
          isPrimary={isPrimary}
          size={size}
          icons={{ iconPrimary: <TikTok /> }}
          link={{
            _type: "link",
            type: "external",
            newTab: true,
            slug: tiktok,
          }}
        />
      )}
    </div>
  );
};
